// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vmiddle[data-v-2bc32c1a]{vertical-align:middle!important}a[data-v-2bc32c1a]:link,a[data-v-2bc32c1a]:visited{text-decoration:none}a[data-v-2bc32c1a]:active,a[data-v-2bc32c1a]:hover{text-decoration:underline}", ""]);
// Exports
module.exports = exports;
